import {formEncodedApi} from 'nutshell-core/api';
import {mapEntityToDisplayOption} from 'nutshell-core/utils';
import type {Entity, DisplayOptionEntity} from 'nutshell-core/utils';

import {ROWS} from 'shells/peep-cards/consts';
import type {ContactInput} from 'shells/peep-cards/contact-card/types';

export function getPotentialContacts(input: {
    contactInput: ContactInput;
    relatedAccountIds: string[];
    alreadyAddedContactsIds: string[];
}): Promise<DisplayOptionEntity[]> {
    const {contactInput, relatedAccountIds, alreadyAddedContactsIds} = input;

    const fields = [
        {name: 'name', value: contactInput.name},
        {name: 'email', value: contactInput.email},
        {name: 'phone', value: contactInput.phoneNumber},
        {name: 'description', value: contactInput.description},
    ];

    const data = {
        rows: fields.every((f) => !f.value) ? 50 : ROWS,
        fields,
        relatedAccountIds,
    } as const;

    return (
        formEncodedApi
            .get('/solr/find-potential-contacts-for-lead-form.json', {
                ...data,
            })
            // @ts-expect-error
            .then((response) => response.json())
            .then((response: {results: Entity[]}) => {
                const results: Entity[] = response.results ? response.results : [];

                return results
                    .map<DisplayOptionEntity>((entity: Entity) => {
                        return mapEntityToDisplayOption(entity);
                    })
                    .filter((entity: DisplayOptionEntity) => {
                        return (
                            alreadyAddedContactsIds && !alreadyAddedContactsIds.includes(entity.id)
                        );
                    });
            })
    );
}
